"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

var index_1 = require("../index");

exports.normalizeProposal = function (proposal) {
  var processed = Object.assign({}, proposal);
  delete processed.estimatedPrice;
  processed.fees = {
    tax: {
      title: "Sales Tax (6.35%)",
      price: {
        currency: processed.rental.currency,
        amount: processed.rental.amount * 0.0635
      }
    },
    service: {
      title: "Service Fee (10%)",
      price: {
        currency: processed.rental.currency,
        amount: processed.rental.amount * 0.1
      }
    },
    paymentProcessing: {
      title: "Payment Processing (2.9%)",
      price: {
        currency: processed.rental.currency,
        amount: processed.rental.amount * 0.029
      }
    }
  };
  processed.total = index_1.addPrices([processed.rental, index_1.addPrices(Object.values(processed.fees).map(function (fee) {
    return fee.price;
  }))]);
  processed.status = "PROPOSED";
  var booking = processed;
  return booking;
};

exports.displayBookingTimeRange = function (booking) {
  return moment_1.default(booking.startTime, "HH:mm").format("h:mm A") + " - \n            " + moment_1.default(booking.startTime, "HH:mm").add(booking.length, "hours").format("h:mm A");
};

exports.validateBooking = function (booking) {
  var errors = [];

  if (!booking.user) {
    errors.push("user");
  }

  if (!booking.status) {
    errors.push("status");
  }

  if (!booking.time) {
    errors.push("time");
  }

  if (booking.status !== "INQUIRY") {
    if (!(booking.rental && booking.rental.amount > 0)) errors.push("rental");
    if (!(booking.fees && index_1.addPrices(Object.values(booking.fees).map(function (fee) {
      return fee.price;
    })).amount > 0)) errors.push("fees");
    if (!(booking.total && booking.total.amount > 0)) errors.push("total");
  }

  if (errors.length > 0) {
    return {
      valid: false,
      errors: errors
    };
  } else {
    return {
      valid: true
    };
  }
};

exports.validatePayment = function (payment) {
  var errors = [];

  if (!payment.user) {
    errors.push("user");
  }

  if (!payment.venue) {
    errors.push("venue");
  }

  if (!payment.createdTime) {
    errors.push("time");
  }

  if (payment.type !== "DEPOSIT" && payment.type !== "PAYMENT" && payment.type !== "REFUND") {
    errors.push("type");
  }

  if (!payment.booking) {
    errors.push("booking");
  }

  if (errors.length > 0) {
    return {
      valid: false,
      errors: errors
    };
  } else {
    return {
      valid: true
    };
  }
};